import { Validators } from '@angular/forms';

export class LoanDetailsModel {
    purpose = {
        value: null,
        validation: Validators.compose([
            Validators.required
        ])
    };
    product = {
        value: null,
        validation: Validators.compose([
            Validators.required
        ])
    };
    productPricing = {
        value: null,
        validation: Validators.compose([])
    };
    securityType = {
      value: null,
        validation: Validators.compose([])
    };
    /* description = {
        value: null,
        validation: Validators.compose([
            Validators.required
        ])
    }; */
}
